import { ReactNode } from 'react';
import { Icon } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export interface NoticeProps {
  className?: string;
  message?: ReactNode;
  type: 'info' | 'success' | 'warning' | 'error' | 'none';
}

export const Notice = ({ type, message, className }: NoticeProps) => {
  const iconProps = iconVariants[type];

  return (
    <div className={cn(styles.wrapper, iconProps?.twClass, className)}>
      <div className="flex items-center gap-1">
        <Icon icon="" size={12} className="self-baseline" />
        <p className={cn('message', styles.message)}>{message}</p>
      </div>
    </div>
  );
};

const iconVariants: Record<NoticeProps['type'], { twClass: string; icon: string } | undefined> = {
  error: {
    twClass: cn('border-base-attention-red text-attention-red', '[&_.message]:text-attention-red'),
    icon: 'info'
  },
  success: undefined,
  warning: undefined,
  info: undefined,
  none: undefined
};

const styles = {
  wrapper: cn('flex min-h-10 flex-none items-center gap-1 rounded-[28px] border-[transparent] bg-black-10 px-4 py-2'),
  message: cn('text-base leading-[120%] font-normal text-primary')
};
